module.exports = __webpack_public_path__ + "4c1c7d2207438a06744b83eb75541982.pdf";